import { createPortal } from 'react-dom';
import { AlertTriangle, CheckCircle2, Info, X, XCircle } from 'lucide-react';
import { useToast } from '../../context/ToastContext';
import { cn } from '../../lib/cn';

const TYPES = {
  success: { icon: CheckCircle2, classes: 'border-success-line bg-success-soft text-success' },
  error: { icon: XCircle, classes: 'border-danger-line bg-danger-soft text-danger' },
  warn: { icon: AlertTriangle, classes: 'border-warn-line bg-warn-soft text-warn' },
  info: { icon: Info, classes: 'border-info-line bg-info-soft text-info' },
};

export function Toaster() {
  const { toasts, dismiss } = useToast();

  if (toasts.length === 0) return null;

  return createPortal(
    <div
      aria-live="polite"
      className="pointer-events-none fixed bottom-4 right-4 z-[90] flex w-[min(24rem,calc(100vw-2rem))] flex-col gap-2"
    >
      {toasts.map((toast) => {
        const { icon: Icon, classes } = TYPES[toast.type] || TYPES.info;
        return (
          <div
            key={toast.id}
            role={toast.type === 'error' ? 'alert' : 'status'}
            className={cn(
              'pointer-events-auto flex animate-slide-in-right items-start gap-2.5 rounded-lg border p-3 shadow-pop backdrop-blur',
              classes
            )}
          >
            <Icon size={16} className="mt-0.5 shrink-0" />
            <div className="min-w-0 flex-1">
              {toast.title && <p className="text-xs font-semibold">{toast.title}</p>}
              <p className="break-words text-xs leading-relaxed">{toast.message}</p>
            </div>
            <button
              type="button"
              onClick={() => dismiss(toast.id)}
              aria-label="Zamknij powiadomienie"
              className="-mr-1 -mt-1 shrink-0 rounded p-1 opacity-60 transition-opacity hover:opacity-100"
            >
              <X size={13} />
            </button>
          </div>
        );
      })}
    </div>,
    document.body
  );
}

export default Toaster;
